// extracted by mini-css-extract-plugin
export default {"mainTable":"Table_mainTable__i+aZL"};